import { CASINO_GAME_PARTNERS_SEARCH_TYPES, initStore } from '../../../common';
import { actions } from './actions';

export const gamePartnersStore = (): void => {
	const initialState = {
		slice: 'CASINO_GAME_PARTNERS',
		gamePartners: [],
		gamesLoading: false,
		savingData: false,
		pagesTotal: 1,
		currentPage: 1,
		rows: [],
		bulkRows: [],
		columns: [],
		perPage: '10',
		// active: [
		// 	{ value: '0', label: 'Disabled', isChecked: false },
		// 	{ value: '1', label: 'Enabled', isChecked: false },
		// ],
		filtering: false,
		filters: [{ name: 'searchType', value: CASINO_GAME_PARTNERS_SEARCH_TYPES[0].value }],
		globalErrors: [],
		selectedGamePartner: null,
		gamePartnerForm: {
			game_name: '',
			game_id: '',
		},
		formErrors: null,
		globalSuccess: '',
		gameData: [],
	};

	initStore(actions, initialState);
};
